import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  loading: false,
  queues: [],
  accounts: [],
  error: null,
  meaningAnalysisWidgets: {},
  genericWidgets: {},
  timeWidgets: {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
